import { api, API_BASE_URL } from './api';
import { createDownloader, downloadErrorFor, type DownloadError } from './download';

/**
 * Every Admin file download from the Api goes through here (Warren,
 * 29 Oct 2026). The signed-in ky client attaches the Bearer token, and a
 * 401 gets the shared refresh and one replay like every other call; the
 * rules and tests are in lib/download.ts.
 *
 *   await downloadAuthed(driverReportPdfPath(id), 'report.pdf');
 *
 * Never an `<a href download>` or `window.open` to an Api route: those
 * cannot carry the token and the Api answers 401 (lib/download.test.ts
 * guards the source).
 *
 * Downloads get two minutes, not the client's 30 s: a 10000-row report PDF
 * is built on request.
 */
const DOWNLOAD_TIMEOUT_MS = 120_000;

const downloader = createDownloader({
  get: (path) => api.get(path, { timeout: DOWNLOAD_TIMEOUT_MS }),
  apiBase: API_BASE_URL,
});

export const downloadAuthed = downloader.download;
export const isDownloadInFlight = downloader.isInFlight;

/** The message a page shows for a failed download. */
export async function downloadErrorMessage(err: unknown): Promise<string> {
  const e: DownloadError = await downloadErrorFor(err);
  return e.message;
}
